import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import api from "@/utils/api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double-processing in React StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);

    if (!match) {
      navigate("/login", { replace: true });
      return;
    }

    const session_id = match[1];

    const processCallback = async () => {
      try {
        const { data } = await api.post("/auth/google/callback", { session_id });
        setUser(data.data.user);
        // Clear the hash from URL
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true, state: { user: data.data.user } });
      } catch {
        navigate("/login", { replace: true });
      }
    };

    processCallback();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-emerald-700 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-slate-600 font-medium">Signing you in...</p>
      </div>
    </div>
  );
}
